import { create } from 'zustand';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface Notification {
  id: string;
  type: NotificationType;
  title: string;
  message: string;
  duration?: number;
}

interface NotificationState {
  notifications: Notification[];
  addNotification: (notification: Omit<Notification, 'id'>) => void;
  removeNotification: (id: string) => void;
}

export const useNotificationStore = create<NotificationState>(set => ({
  notifications: [],
  addNotification: notification => {
    const id = Math.random().toString(36).substring(2, 9);
    const newNotification = { ...notification, id };

    set(state => ({
      notifications: [newNotification, ...state.notifications],
    }));

    if (notification.duration !== 0) {
      setTimeout(() => {
        set(state => ({
          notifications: state.notifications.filter(n => n.id !== id),
        }));
      }, notification.duration || 5000);
    }
  },
  removeNotification: id =>
    set(state => ({
      notifications: state.notifications.filter(n => n.id !== id),
    })),
}));
